import Hero from "../components/Hero";
import PackshotGallery from "../components/PackshotGallery";
import Benefits from "../components/Benefits";
import Manifesto from "../components/Manifesto";
import HomeCta from "../components/HomeCta";

export default function Home() {
  return (
    <>
      <Hero />
      <PackshotGallery />
      <Benefits />
      <Manifesto />
      <HomeCta />
    </>
  );
}
